const env_process = {
    namespaced: true,
    state: {
        process: process.env.NODE_ENV,
    },
    getters: {
        statusProcess: (state) => {
            return state.process;
        },
    },
};

export default env_process;